document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.js-menu-btn');
  const contents = document.querySelectorAll('.js-menu-content');

  buttons.forEach(btn => {
    btn.addEventListener('click', (e) => {

      // Oculta todos los contenidos
      contents.forEach(content => content.classList.add('tw-hidden'));

      // Busca el contenido dentro del botón actual
      const content = btn.querySelector('.js-menu-content');
      if (content) {
        // Si ya estaba visible, lo oculta (toggle)
        if (!content.classList.contains('tw-hidden')) {
          content.classList.add('tw-hidden');
        } else {
          content.classList.remove('tw-hidden');
        }
      }
    });
  });
});
